export default {
  authed: false,
  verified: false,
  firstLoad: true,
  loading: false,
  user: null,
  settings: null,
  userProjects: [],
  menuRightCls: '',
  showAdmin: false
}



// WEBPACK FOOTER //
// ./src/store/modules/user/state.js